<template>
  <CFooter :fixed="false" class="justify-content-center">
    <div>
      <a href="/" target="_blank">Developers dashboard</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} PUFsecurity Corp.</span>
    </div>
    <!--<div class="ml-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://coreui.io/vue">CoreUI for Vue</a>
    </div>-->
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
